/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Platforms_TitleInputs */

const en_fc_home_platforms_title = /** @type {(inputs: Fc_Home_Platforms_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download the FilmCraft video editor for every platform`)
};

/**
* | output |
* | --- |
* | "Download the FilmCraft video editor for every platform" |
*
* @param {Fc_Home_Platforms_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_platforms_title = /** @type {((inputs?: Fc_Home_Platforms_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Platforms_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_platforms_title(inputs)
});
export { fc_home_platforms_title as "fc.home.platforms.title" }